module.exports = __webpack_public_path__ + "img/riga.c2ea8e86.png";